<template>
    <div id="mapper_wrapper">
        <p v-if="headers.length === 0">Upload a CSV file to see your columns here.</p>
        <div v-else>
            <div class="mapper_row">
                <div class="third text-left">
                    <p>Our System Fields</p></div>
                <div class="third">
                    <p>Your File Headers</p></div>
                <div class="third text-right">
                    <p>Preview</p>
                </div>
            </div>
            <div class="mapper_row">
                <div class="third text-left">
                  <p class="header-label">Order Ref<span class="asterisk">*</span></p>
                  <span class="dark-bg">Required</span>
                </div>
                <div class="third">
                  <select v-model="orderIdHeader" class="header-dropdown">
                    <option :key="`h-${header}`" v-for="header in headers">{{ header }}</option>
                  </select>
                </div>
                <div class="third text-right">
                  {{ sampleRow[orderIdHeader] }}
                </div>
            </div>
            <div class="mapper_row">
                <div class="third text-left">
                  <p class="header-label">Amount<span class="asterisk">*</span></p>
                  <span class="dark-bg">Required</span>
                </div>
                <div class="third">
                  <select v-model="amountHeader" class="header-dropdown">
                    <option :key="`h-${header}`" v-for="header in headers">{{ header }}</option>
                  </select>
                </div>
                <div class="third text-right">
                  {{ sampleRow[amountHeader] }}
                </div>
            </div>
            <div class="mapper_row">
                <div class="third text-left">
                  <p class="header-label">Phone Number<span class="asterisk">*</span></p>
                  <span class="dark-bg">Required</span>
                </div>
                <div class="third">
                  <select v-model="phoneHeader" class="header-dropdown">
                    <option :key="`h-${header}`" v-for="header in headers">{{ header }}</option>
                  </select>
                </div>
                <div class="third text-right">
                  {{ sampleRow[phoneHeader] }}
                </div>
            </div>
            <div class="mapper_row">
                <div class="third text-left">
                  <p class="header-label">Meter<span class="asterisk">*</span></p>
                  <span class="dark-bg">Required</span>
                </div>
                <div class="third">
                  <select v-model="meterHeader" class="header-dropdown">
                    <option :key="`h-${header}`" v-for="header in headers">{{ header }}</option>
                  </select>
                </div>
                <div class="third text-right">
                  {{ sampleRow[meterHeader] }}
                </div>
            </div>
            <div class="mapper_row">
                <div class="third text-left">
                  <p class="header-label">Disco<span class="asterisk">*</span></p>
                  <span class="dark-bg">Required</span>
                </div>
                <div class="third">
                  <select v-model="discoHeader" class="header-dropdown">
                    <option :key="`h-${header}`" v-for="header in headers">{{ header }}</option>
                  </select>
                </div>
                <div class="third text-right">
                  {{ sampleRow[discoHeader] }}
                </div>
            </div>
            <div class="mapper_row">
                <div class="third text-left">
                  <p class="header-label">Vend Type<span class="asterisk">*</span></p>
                  <span class="dark-bg">Required</span>
                </div>
                <div class="third">
                  <select v-model="vendTypeHeader" class="header-dropdown">
                    <option :key="`h-${header}`" v-for="header in headers">{{ header }}</option>
                  </select>
                </div>
                <div class="third text-right">
                  {{ sampleRow[vendTypeHeader] }}
                </div>
            </div>
            <div class="mapper_row">
                <div class="third text-left">
                  <p class="header-label">Payment Type<span class="asterisk">*</span></p>
                  <span class="dark-bg">Required</span>
                </div>
                <div class="third">
                  <select v-model="paymentTypeHeader" class="header-dropdown">
                    <option :key="`h-${header}`" v-for="header in headers">{{ header }}</option>
                  </select>
                </div>
                <div class="third text-right">
                  {{ sampleRow[paymentTypeHeader] }}
                </div>
            </div>
            <div class="mapper_row">
                <div class="third text-left">
                  <p class="header-label">Vertical<span class="asterisk">*</span></p>
                  <span class="dark-bg">Required</span>
                </div>
                <div class="third">
                  <select v-model="verticalHeader" class="header-dropdown">
                    <option :key="`h-${header}`" v-for="header in headers">{{ header }}</option>
                  </select>
                </div>
                <div class="third text-right">
                  {{ sampleRow[verticalHeader] }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
  props: {
    headers: {
      type: Array,
      required: true,
    },
    sampleRow: {
      type: Object,
      required: true,
    },
    canContinue: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      orderIdHeader: null,
      amountHeader: null,
      phoneHeader: null,
      meterHeader: null,
      discoHeader: null,
      vendTypeHeader: null,
      paymentTypeHeader: null,
      verticalHeader: null,
    };
  },
  computed: {
    headersValid() {
      const valid = this.orderIdHeader != null
       && this.amountHeader != null
       && this.phoneHeader != null
       && this.meterHeader != null
       && this.discoHeader != null
      && this.vendTypeHeader != null
      && this.paymentTypeHeader != null
      && this.verticalHeader != null;

      return valid;
    },
  },
  watch: {
    headersValid: {
      handler(valid) {
        this.canContinue(valid);

        if (!valid) return;

        this.$emit('submitMappedHeaders', {
          orderIdHeader: this.orderIdHeader,
          amountHeader: this.amountHeader,
          phoneHeader: this.phoneHeader,
          meterHeader: this.meterHeader,
          discoHeader: this.discoHeader,
          vendTypeHeader: this.vendTypeHeader,
          paymentTypeHeader: this.paymentTypeHeader,
          verticalHeader: this.verticalHeader,
        });
      },
      immediate: true,
    },
  },
};
</script>
<style>
  .header-dropdown {
    width: 250px;
    height: 32px;
    padding: 0px 8px;
    border: none;
  }

  .asterisk {
    color: #ff0000;
    font-size: 16px;
  }

  .header-label {
    font-size: 14px !important;
    font-weight: 700 !important;
    margin: 0;
    margin-bottom: 0px;
  }

  .dark-bg {
    font-size: 10px;
    background: #AAAAAA;
    color: #475569;
    padding: 4px;
    box-sizing: border-box;
    border-radius: 4px;
  }

  .text-left {
    text-align: left;
  }

  .text-right {
    text-align: right;
  }

  .third {
    width: 33.33333333%;
    text-align: center;
  }

  .third > p {
    font-weight: 700;
    font-size: 10px;
    color: rgb(112, 112, 112);
  }

  #mapper_wrapper {
      width: 100%;
      height: auto;
      min-height: 120px;
      background: #EEEEEE;
      border: solid 2px #E2E8F0;
      border-radius: 12px;
      padding: 16px;
      box-sizing: border-box;
  }

  #mapper_wrapper > p {
      text-align: center;
      width: 100%;
      line-height: 120px;
      margin: 0;
      font-weight: 400;
      color: #b8b8b8;
  }

  .mapper_row {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      margin-bottom: 32px;
      height: 32px;
  }

  .mapper_row:last-child {
    margin-bottom: 24px;
  }
</style>
